import {Component, HostListener, Input, OnInit} from '@angular/core';
import {Board} from "./board";

@Component({
  selector: 'app-board',
  templateUrl: './board.component.html',
  styleUrls: ['./board.component.css']
})
export class BoardComponent implements OnInit {

  @Input() board: Board;
  @Input() width = 500;

  private swipeCoord: [number, number];
  private swipeTime: number;

  constructor() { }

  ngOnInit(): void {
  }

  get style(): any {
    return {
      width: `${this.width}px`,
      height: `${this.width*this.board.rows/this.board.cols/2}px`
    }
  }

  get brickSize(): number {
    return this.width / this.board.cols - 2;
  }

  get plateStyle(): any {
    return {
      left: `${this.width*(this.board.plate.x-0.5*this.board.plate.width)}px`
    }
  }

  get ballStyle(): any {
    return {
      left: `${this.width*(this.board.ball.x-this.board.ball.r)}px`,
      top: `${this.width*(this.board.ball.y-this.board.ball.r)}px`,
      width: `${this.width*(this.board.ball.r*2)}px`,
      height: `${this.width*(this.board.ball.r*2)}px`

    }
  }

  @HostListener('document:keydown',['$event'])
  handleKey(e: KeyboardEvent): boolean {
    switch(e.key) {
      case 'ArrowLeft': this.board.plate.accel -= 0.002; break;
      case 'ArrowRight': this.board.plate.accel += 0.002; break;
    }
    return true;
  }

  swipe(e: TouchEvent, action: 'start'|'end'): boolean {
    console.log(`swipe ${action}`, e);
    const coord: [number, number] = [e.changedTouches[0].clientX, e.changedTouches[0].clientY];
    const time = new Date().getTime();
    if (action === 'start') {
      this.swipeCoord = coord;
      this.swipeTime = time;
    } else {
      const direction = [coord[0] - this.swipeCoord[0], coord[1] - this.swipeCoord[1]];
      const duration = time - this.swipeTime;

      if (duration < 1500) {
        const dax = Math.abs(direction[0]);
        const day = Math.abs(direction[1]);
        const len = Math.sqrt(direction.reduce((r, v) => r + v * v, 0));
        if ( dax > this.brickSize && dax > day * 3)
        { // Horizontal enough
          const swipe = direction[0] < 0 ? 'ArrowLeft' : 'ArrowRight';
          this.board.handleKey(swipe, dax/this.brickSize/4);
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
        if ( day > this.brickSize && day > dax * 3)
        { // Horizontal enough
          const swipe = direction[1] < 0 ? 'ArrowUp' : 'ArrowDown';
          this.board.handleKey(swipe);
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
        if (len < this.brickSize) {
          this.board.handleKey(' ');
          e.preventDefault();
          e.stopPropagation();
          return false;
        }

        if (len > this.brickSize && dax >= day * 0.7 && day >= dax * 0.7) {
          // diagonal ?
        }
      }
    }
    return true;
  }

}
